const SearchVisualIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.14426 2.49998H2.5V9.14425M14.8557 2.49998H21.5V9.14425M14.8557 21.5H21.5V14.8557M9.14426 21.5H2.5V14.8557"
          stroke="#7F7B87"
          strokeWidth="1.5"
        />
        <path
          d="M15 15L17 17M16 11.5C16 9.01472 13.9853 7 11.5 7C9.01472 7 7 9.01472 7 11.5C7 13.9853 9.01472 16 11.5 16C13.9853 16 16 13.9853 16 11.5Z"
          stroke="#7F7B87"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default SearchVisualIcon;
